const U = (id, w = 1920, extra = "") =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80${extra}`;

export const IMG = {
  hero: U("1544984243-ec57ea16fe25", 2400),
  intro: U("1564078516393-cf04bd966897", 1600),
  livingAlt: U("1628744876497-eb30460be9f6", 1600),
  archPool: U("1719166428968-859fc90672c4", 1600),
  archMinimal: U("1616577711667-3da65b20c36a", 1600),
  villaDusk: U("1600596542815-ffad4c1539a9", 1920),
  luxInterior: U("1600607687939-ce8a6c25118c", 1920),
  panoImage: U("1613490493576-7fde63acd811", 2800, "&h=1100"),
  exteriorDay: U("1600585154340-be6161a56a0c", 1600),
  villaNight: U("1613490493576-7fde63acd811", 1920),
  twilightPool: U("1512917774080-9991f1c4c750", 2400),
  interiorDesign: U("1600210492486-724fe5c67fb0", 1600),
  livingRoom: U("1616486338812-3dadae4b4ace", 1600),
  kitchen: U("1556912167-f556f1f39fdf", 1600),
  bathroom: U("1620626011761-996317b8d101", 1600),
  apartment: U("1522708323590-d24dbb6b0267", 1600),
  modernHouse: U("1580587771525-78b9dba3b914", 1600),
  houseNight: U("1564013799919-ab600027ffc6", 1600),
  houseDay: U("1568605114967-8130f3a36994", 1600),
  aerialResort: U("1540541338287-41700207dee6", 1600),
  bedroom: U("1502005229762-cf1b2da7c5d6", 1600),
  dayToDuskBefore: "/assets/day-to-dusk-b.webp",
  dayToDuskAfter: "/assets/day-to-dusk-a.webp",
  interiorBefore: "/assets/interior-pair-2.webp",
  interiorAfter: "/assets/interior-pair-1.webp",
  bedroomBefore: "/assets/bedroom-2.webp",
  bedroomAfter: "/assets/bedroom-1.webp",
  poolBefore: "/assets/pool-2.webp",
  poolAfter: "/assets/pool-1.webp",
  towerBefore: "/assets/tower-2.webp",
  towerAfter: "/assets/tower-1.webp",
  windowPullBefore: "/assets/windowpull-before.webp",
  windowPullAfter: "/assets/windowpull-after.webp",
  aerialSite: "/assets/aerial-site.jpg",
  twilightBrick: "/assets/twilight-brick.webp",
  timberKitchen: "/assets/timber-kitchen.webp",
  gardenLiving: "/assets/garden-living.webp",
  twilightRanchBefore: "/assets/twilight-ranch-before.webp",
  twilightRanchAfter: "/assets/twilight-ranch-after.webp",
};

export const HERO_VIDEO_URL =
  "https://videos.pexels.com/video-files/3773486/3773486-hd_1920_1080_30fps.mp4";
export const VIDEO_URL =
  "https://cdn.pixabay.com/video/2024/05/08/211152_large.mp4";
export const WHATSAPP_URL = "https://wa.me/919535753697";
export const EMAIL = "info@vcontractz.com";

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Before & After", href: "#before-after" },
  { label: "How It Works", href: "#workflow" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    num: "01",
    title: "Natural Twilight",
    desc: "Capture the beauty of twilight — naturally. Our expert editors refine images captured during dusk, enhancing colour, contrast, exposure and low-light details to create polished, atmospheric photographs that feel authentic and inviting. Natural twilight photography showcases a property in its most flattering light — bringing warmth, depth and character to every frame.",
    items: ["Dusk Capture Enhancement", "Colour & Contrast", "Exposure Balance", "Low-Light Detail", "Authentic Atmosphere"],
    cta: "Explore Natural Twilight",
  },
  {
    num: "02",
    title: "Virtual Twilight",
    desc: "Transform daytime property photos into stunning golden-hour and twilight scenes. Our editors enhance skies, balance shadows and add realistic warm lighting to create captivating images that make your listings stand out. Captured at dusk? Choose Natural Twilight for an authentic finish.",
    items: ["Day to Dusk Conversion", "Golden-Hour Skies", "Shadow Balancing", "Warm Interior Lighting", "Window Glow"],
    cta: "Explore Virtual Twilight",
    featured: true,
  },
  {
    num: "03",
    title: "Rain to Shine",
    desc: "Neither snow, nor rain, nor gloomy day should ruin your listing photos. We meticulously eliminate any unwanted signs of bad weather — rain clouds, snow or wet sidewalks — transforming the sky and puddles into a clear, beautiful day. Reduce rescheduling and reshooting with brilliant editors on your side.",
    items: ["Rain Cloud Removal", "Snow Removal", "Wet Surface Cleanup", "Sky Transformation", "Puddle Removal"],
    cta: "Explore Rain to Shine",
  },
  {
    num: "04",
    title: "Blended Brackets (HDR)",
    desc: "Combine three or more exposures into one perfectly balanced image. Our editors hand-blend each frame with precise window pulls to deliver natural brightness, rich detail and exceptional depth — polished, professional real-estate photography that brings every space to life.",
    items: ["3+ Exposure Blending", "Hand-Blended Frames", "Precise Window Pulls", "Natural Brightness", "Rich Detail & Depth"],
    cta: "Explore HDR Editing",
    to: "/photo-editing",
  },
  {
    num: "05",
    title: "Single Exposure",
    desc: "Quickly and inexpensively transform a single exposure or pre-blended exposures into a refined, finished image. We adjust colours, contrast and lighting to achieve a balanced and professional look.",
    items: ["Colour Adjustment", "Contrast & Lighting", "Fast Turnaround", "Budget-Friendly", "Pre-Blended Support"],
    cta: "Explore Single Exposure",
    to: "/photo-editing",
  },
  {
    num: "06",
    title: "Flambient",
    desc: "Blend flash and ambient exposures to create sophisticated, true-to-life images with exceptional depth and character. Our editors carefully balance each exposure to shape light, refine atmosphere and highlight architectural details — a premium editing style trusted by high-end real estate and architectural photographers.",
    items: ["Flash + Ambient Blending", "Light Shaping", "Atmosphere Refinement", "Architectural Detail", "True-to-Life Colour"],
    cta: "Explore Flambient",
    to: "/photo-editing",
  },
  {
    num: "07",
    title: "Lawn Replacement",
    desc: "Give every property a greener first impression. Replace dull, patchy or damaged lawns with lush, natural-looking grass. Our editors enhance curb appeal with realistic textures and seamless blending, giving your property a fresh, polished appearance. Beautiful lawns. Stronger first impressions.",
    items: ["Lush Grass Replacement", "Realistic Textures", "Seamless Blending", "Patchy Lawn Repair", "Curb Appeal"],
    cta: "Explore Lawn Replacement",
  },
];

export const STEPS = [
  { num: "01", title: "Upload", desc: "Send your RAW images, panoramas or video footage through your preferred channel." },
  { num: "02", title: "Edit", desc: "Our professional editors work according to your preferred style and specifications." },
  { num: "03", title: "Quality Control", desc: "Every project passes a dedicated quality review before it leaves the studio." },
  { num: "04", title: "Deliver", desc: "Receive polished, market-ready visuals through your preferred delivery method." },
];

export const STRENGTHS = [
  "Professional Quality",
  "Consistency",
  "Reliable Turnaround",
  "Scalable Workflow",
  "Dedicated Quality Control",
  "Global Client Support",
  "Secure File Handling",
];

export const MARQUEE_PHRASES = [
  "Every Frame, Refined",
  "Your Vision, Our Craft",
  "Made to Feel Real",
  "Luxury Should Look Effortless",
  "Visuals That Move Property",
  "Post-Production Without Compromise",
];

export const PORTFOLIO_FILTERS = ["All", "Interiors", "Exteriors", "Twilight", "Drone"];

export const PORTFOLIO = [
  { img: IMG.interiorAfter, cat: "Interiors", title: "The Marble Living Room", service: "Flambient Editing", tall: true, real: true },
  { img: IMG.dayToDuskAfter, cat: "Twilight", title: "Twilight on the Ridge", service: "Day to Dusk", tall: false, real: true },
  { img: IMG.towerAfter, cat: "Exteriors", title: "The Landmark Tower", service: "Architectural Enhancement", tall: false, real: true },
  { img: IMG.aerialSite, cat: "Drone", title: "Wallan Commercial Site", service: "Drone Editing & Annotation", tall: false, real: true },
  { img: IMG.gardenLiving, cat: "Interiors", title: "The Garden Pavilion", service: "HDR Interior Enhancement", tall: false, real: true },
  { img: IMG.timberKitchen, cat: "Interiors", title: "The Timber Bar Kitchen", service: "Flambient Editing", tall: false, real: true },
  { img: IMG.bedroomAfter, cat: "Interiors", title: "The Amber Suite", service: "HDR & Window Pull", tall: true, real: true },
  { img: IMG.poolAfter, cat: "Exteriors", title: "The Clubhouse Pool", service: "Sky Replacement & Colour", tall: false, real: true },
  { img: IMG.windowPullAfter, cat: "Interiors", title: "The Pendant Suite", service: "Window Pull & Colour", tall: false, real: true },
  { img: IMG.twilightBrick, cat: "Twilight", title: "The Brick House at Dusk", service: "Day to Dusk", tall: false, real: true },
  { img: IMG.twilightRanchAfter, cat: "Twilight", title: "The Ranch at Dusk", service: "Natural Twilight", tall: false, real: true },
];

export const TESTIMONIALS = [
  {
    quote: "I sent them a dusk exterior at 6pm and woke up to the frame my client called 'the one that sold the house'. They just get it.",
    name: "Client Name",
    role: "Real Estate Photographer — Location",
    initials: "CN",
  },
  {
    quote: "Other editors made my photos look like everyone else's. VCONTRACTZ studied my portfolio first — now I can't tell where my Lightroom work ends and theirs begins.",
    name: "Client Name",
    role: "Property Marketing Agency — Location",
    initials: "CN",
  },
  {
    quote: "Three years, thousands of images, one late-night panic order before a launch — they've never missed. It feels less like outsourcing and more like a quiet partner.",
    name: "Client Name",
    role: "Luxury Brokerage — Location",
    initials: "CN",
  },
];

export const FAQS = [
  { q: "Can I really get my photos in 24 hours?", a: "Yes. Standard photo editing orders with clear instructions are returned within 24 hours — often sooner. Larger volumes, panoramas and video projects are scheduled with you before we begin, so every deadline is agreed, never assumed." },
  { q: "What if I want to change something in my photos after delivery?", a: "Simply tell us what to adjust. Every project includes revision rounds — we refine until the frame matches your vision, and your feedback is folded into your style profile so future orders need fewer notes." },
  { q: "How many photos do I need to order for HDR or Flambient editing?", a: "There is no minimum. Send a single image or a full listing set — HDR and Flambient editing are priced per photo, so you can begin with our free 3-photo trial and scale whenever you are ready." },
  { q: "What type of photo files do you prefer for optimal results?", a: "RAW, DNG or TIFF files give our editors the most latitude for blending and grading, and produce the finest results. High-resolution JPEGs also work well when RAW is not available." },
  { q: "How many brackets are preferred for HDR photos?", a: "Three to five bracketed exposures at ±2 EV is ideal for a natural, detailed blend. For high-contrast interiors with bright windows, five brackets give the cleanest window pulls." },
  { q: "Can I pass along instructions if I have a specific editing style?", a: "Absolutely — that is how we work best. Share reference images, presets or written notes and we build a style profile for your account, so every delivery matches your signature look." },
  { q: "Will I have a dedicated editor for all my projects?", a: "Yes. Recurring clients are assigned a dedicated editor — or a dedicated team for higher volumes — so your style stays consistent across every project without re-explaining it each time." },
  { q: "What are the available payment options?", a: "We keep it simple: bank transfer, PayPal or major credit cards, with per-project or monthly invoicing for recurring work. Terms are confirmed with your custom pricing before we begin." },
  { q: "How can I upload photos to you?", a: "Through whatever you already use — Dropbox, Google Drive or WeTransfer. Paste a link in the enquiry form and we take it from there; dedicated upload folders are set up for recurring clients." },
];

export const SERVICE_OPTIONS = [
  "Photo Editing",
  "HDR",
  "Flambient",
  "Panorama / 360°",
  "Day to Dusk",
  "Video Editing",
  "Virtual Staging",
  "Retouching",
  "Drone Editing",
];

export const VOLUME_OPTIONS = [
  "1 – 50 images / month",
  "50 – 200 images / month",
  "200 – 500 images / month",
  "500+ images / month",
  "Video projects",
  "One-time project",
];
